import React from "react";
import * as PrimitiveVisuallyHidden from "@radix-ui/react-visually-hidden";

export default function VisuallyHidden({ ...delegated }) {
  return <PrimitiveVisuallyHidden.Root {...delegated} />;
}
